// @flow

// Libs
import { connect } from 'react-redux'

// Components
import SoilTestLayers from '../components/SoilTestLayers'

// Selectors
import {
  selectedSoilTestFilter$,
  imageryLayersToggled$,
} from 'hfty-map'
import selectedLayer$ from 'hfty-layers/src/selectors/selectedLayer'
import { token$ } from 'fc-auth'

const mapStateToProps = (state: Object): Props => ({
  soilTestFilter: selectedSoilTestFilter$(state),
  layer: selectedLayer$(state),
  toggled: imageryLayersToggled$(state),
  token: token$(state),
})

export default connect(mapStateToProps)(SoilTestLayers)
